import { render, staticRenderFns } from "./modal_warning_person_units.vue?vue&type=template&id=f57ad296&scoped=true"
import script from "./modal_warning_person_units.vue?vue&type=script&lang=js"
export * from "./modal_warning_person_units.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f57ad296",
  null
  
)

export default component.exports